import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import "../styles/CompleteProfile.css"; // CSSでデザイン調整

const bigFiveTraits = [
  { key: "extraversion", label: "外向性", leftLabel: "内向的", rightLabel: "外向的" },
  { key: "agreeableness", label: "お話", leftLabel: "よく話す", rightLabel: "聞き手" },
  { key: "conscientiousness", label: "几帳面さ", leftLabel: "大雑把", rightLabel: "几帳面" },
  { key: "openness", label: "開放性", leftLabel: "保守的", rightLabel: "新しいもの好き" },
  { key: "social", label: "社交性", leftLabel: "一人が好き", rightLabel: "社交的" },
];

const CompleteProfile5 = () => {
  const [user] = useAuthState(auth);
  const [profile, setProfile] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      const fetchProfile = async () => {
        try {
          const docRef = doc(db, "members", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists() && Array.isArray(docSnap.data().personality)) {
            setProfile(docSnap.data().personality);
          } else {
            // 初回登録時に配列として初期化
            const initialProfile = bigFiveTraits.map(trait => ({
              key: trait.key,
              value: 3
            }));
            setProfile(initialProfile);
          }
        } catch (error) {
          console.error("Error fetching profile:", error.message);
          setError("プロフィールの取得中にエラーが発生しました。");
        }
      };
      fetchProfile();
    }
  }, [user]);

  const handleChange = (key, value) => {
    setProfile(prevProfile => 
      prevProfile.map(trait => 
        trait.key === key ? { ...trait, value } : trait
      )
    );
  };

  const handleSave = async () => {
    if (!user) return;
    try {
      const userDocRef = doc(db, "members", user.uid);
      await updateDoc(userDocRef, { personality: profile });
      navigate("/complete-profile6"); // 次のページへ
    } catch (error) {
      console.error("Error saving profile:", error.message);
      setError("プロフィールの保存中にエラーが発生しました。");
    }
  };

  return (
    <div className="complete-profile-container">
      <ProgressBar step={5} totalSteps={6} />
      <h2>あなたの性格を評価してください</h2>
      <br />
      {error && <p className="error-message">{error}</p>}

      <div className="personality-form">
        {bigFiveTraits.map((trait) => {
          const selectedTrait = profile.find(p => p.key === trait.key);
          const selectedValue = selectedTrait ? selectedTrait.value : 3;

          return (
            <div key={trait.key} className="personality-group">
              <label className="complete-profile-container-label">{trait.label}</label>
              <div className="radio-group">
                <span className="trait-label">{trait.leftLabel}</span>
                {[1, 2, 3, 4, 5].map((value) => (
                  <label key={value} className={`radio-label ${selectedValue === value ? "selected" : ""}`}>
                    <input
                      type="radio"
                      name={trait.key}
                      value={value}
                      checked={selectedValue === value}
                      onChange={() => handleChange(trait.key, value)}
                    />
                  </label>
                ))}
                <span className="trait-label">{trait.rightLabel}</span>
              </div>
              <div className="evaluation-label">
                <span>当てはまる</span>
                <span className="center-label">←   　  どちらでもない   　  →</span>
                <span>当てはまる</span>
              </div>
            </div>
          );
        })}
      </div>

      <br />

      <button onClick={handleSave} className="complete-profile-button">次へ</button>
    </div>
  );
};

export default CompleteProfile5;
